import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ClubRoute = () => {
    const { user, loading } = useAuth();

    // A saved session is checked asynchronously; do not redirect during that check.
    if (loading) {
        return (
            <main className="page-wrapper" aria-busy="true">
                <div className="page-body">
                    <div className="container-xl d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading your club…</span>
                        </div>
                    </div>
                </div>
            </main>
        );
    }

    return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ClubRoute;
